// ModalPrompt.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function ModalPrompt({ type = 'alert', message, defaultValue = "", onConfirm, onCancel }) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(defaultValue);

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <p className="modal-message">{message}</p>

        {type === 'input' && (
          <input
            autoFocus
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && onConfirm(inputValue)}
            style={{ width: '100%', padding: '8px', marginBottom: '12px', borderRadius: 4, border: '1px solid #ccc' }}
          />
        )}

        <div className="modal-buttons">
          {(type === 'confirm' || type === 'input') && (
            <button className="modal-button cancel" onClick={onCancel}>
              {t('modal.annuler')}
            </button>
          )}
          <button
            className="modal-button confirm"
            onClick={() => type === 'input' ? onConfirm(inputValue) : onConfirm()}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}